import DepsService from 'services/dependencies';

const CONTEXT = 'dashboard';

const fetchInstatTicketSales = (retailerId) => {
  const { url } = DepsService.rest.widgets.instant.instantTicketSales;
  const queryParams = {};
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export default fetchInstatTicketSales;



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/my-instant-ticket-sales.api.js